
import axios from "axios";

const logout = () => {
  localStorage.removeItem("authToken");
  localStorage.removeItem("user");
  localStorage.removeItem("phone");
  window.location.href = "/";
};

const instance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    "Content-Type": "multipart/form-data",
    Accept: "application/json",
  },
});


instance.interceptors.request.use((config) => {
  const token = localStorage.getItem("authToken");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});


instance.interceptors.response.use(
  (response) => {
    // Global auto-logout if get_profile returns status: 1 (either top-level or in user data)
    if (
      response.config.url.includes("get_profile") &&
      (response.data?.status === 1 || response.data?.data?.status === 1)
    ) {
      logout();
    }
    return response; 
  },
  (error) => {
    if (error.response) {
      const status = error.response.status;

      if (status === 401 || status === 403) {
        logout();
      }
    }

    return Promise.reject(error);
  }
);

export default instance;
